define(['jquery'], function ($) {

    var _baseSelector = '.js-singleselect';
    var _buttonSelector = '.js-singleselect--button';
    var _dropdownSelector = '.js-singleselect--select';
    var _isClosedClass = 'singleselect--isclosed';
    var _highlightClass = 'singleselect--ishighlighted';
    var _isinitializedClass = 'singleselect--isinitialized';

    var setTrap = function () {
        if (!singleselect.clickTrap) {
            singleselect.clickTrap = clickTrap;
            $("body").on("click", clickTrap);
        }
    }

    var unsetTrap = function () {
        if (singleselect.clickTrap) {
            singleselect.clickTrap = null;
            $("body").off("click", clickTrap);
        }
    }

    //click outside of singleselect should close singleselect.
    var clickTrap = function (event) {
        var $target = $(event.target);
        var unset = true;

        var $openDropdown = $(_baseSelector + ":not(." + _isClosedClass + ")");
        if ($openDropdown.length > 0) {
            //check if we are inside open singleselect
            var $parentDropdown = $target.closest(_baseSelector);
            if ($parentDropdown.length && !$parentDropdown.hasClass(_isClosedClass)) {
                unset = false;
            } else {
                singleselect.close($openDropdown);
            }
        }

        if (unset) {
            unsetTrap();
        }
    }

    var singleselect = {
        clickTrap: null,
        init: function () {
            singleselect.setup($(_baseSelector));
        },
        setup: function ($baseElement) {
            // initiate dropdown and it's arrow
            var $button = $baseElement.find(_buttonSelector).first();
            $baseElement.addClass(_isClosedClass);
            $button.attr("aria-expanded", "false");
            $baseElement.addClass(_isinitializedClass);

            // when dropdown is clicked
            var $dropdown = $button.find(_dropdownSelector);
            $dropdown.click(singleselect.handleButtonClick);

            // toggle arrow on enter or space
            $dropdown.on('keypress', function (event) {
                if (event.keyCode == '13' || event.keyCode == '32') {
                    singleselect.handleButtonClick(event);

                    // highlight if pressed enter
                    if (event.keyCode == '13') {
                        var $baseelement = $(event.target).closest(singleselect._baseSelector);
                        singleselect.toggleHighlight($baseelement);
                    }
                }
            });

            // toggle arrow on mouseclick
            $dropdown.change(singleselect.handleDropdownOnChange);
        },
        handleButtonClick: function (event) {
            var $baseElement = $(event.target).closest(_baseSelector);
            var $button = $baseElement.find(_buttonSelector).first();

            if ($baseElement.hasClass(_isClosedClass)) {
                singleselect.open($baseElement, $button);
            } else {
                singleselect.close($baseElement);
            }

            // make sure filter remains highlitghed
            singleselect.toggleHighlight($baseElement);
        },
        handleDropdownOnChange: function (event) {
            // highlight select button onchange
            var $baseElement = $(event.currentTarget).closest(_baseSelector);
            singleselect.toggleHighlight($baseElement);
        },
        toggleHighlight: function ($baseElement) {
            // highlight filter onchange

            var $button = $baseElement.find(_buttonSelector).first();
            var $dropdown = $button.find(_dropdownSelector);

            if ($dropdown[0].selectedIndex > 0) {
                // dont highlight select button
                if (!$baseElement.hasClass(_highlightClass)) {
                    $baseElement.addClass(_highlightClass);
                }
            } else {
                // highlight select button
                $baseElement.removeClass(_highlightClass);
            }
        },
        open: function ($baseElement, $button) {
            // toggle dropdown-arrow
            $baseElement.removeClass(_isClosedClass);
            $button.attr("aria-expanded", "true");

            setTrap();
        },
        close: function ($baseElement) {
            // toggle dropdown-arrow
            var $button = $baseElement.find(_buttonSelector).first();
            $baseElement.addClass(_isClosedClass);
            $button.attr("aria-expanded", "false");
        }
    }
    return singleselect;
});